import {
    ActionsUnion,
    createAction,
} from "@relode/core/components/reducer/actionHelpers";

enum names {
    SET_SELECTED_LEAD_TAB = "SET_SELECTED_LEAD_TAB",
    CLEAR_ERROR = "CLEAR_ERROR",
}
export default names;

export const creators = {
    setSelectedLeadTab: (tab: string) =>
        createAction(names.SET_SELECTED_LEAD_TAB, { tab }),
    clearError: () => createAction(names.CLEAR_ERROR),
};

export type ClientPublicCandidateUIActionTypes = ActionsUnion<typeof creators>;
